import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from './Button'
import { Tooltip } from './Tooltip'
import './playback.css'

/**
 * How a document that plays in order is moved through: a deck's slides.
 *
 * A surface of its own beneath the document, never controls loose on the
 * canvas: the canvas is the table the document lies on, and a button set on it
 * reads as part of the slide. Previous and next lead, the position sits between
 * them, and what the document can do as a whole — present it — trails.
 */
export function Playback({
  label,
  position,
  onPrevious,
  onNext,
  canPrevious,
  canNext,
  children,
}: {
  /** What is being moved through, for the toolbar's name. */
  label: string
  /** Where the reader is, in words: "3 of 12". */
  position: string
  onPrevious: () => void
  onNext: () => void
  canPrevious: boolean
  canNext: boolean
  /** What acts on the whole document, at the trailing edge. */
  children?: ReactNode
}) {
  return (
    <div className="playback" role="toolbar" aria-label={label}>
      <div className="playback__bar">
        <div className="playback__move">
          <Tooltip label="Previous">
            <Button
              variant="quiet"
              aria-label="Previous"
              disabled={!canPrevious}
              onClick={onPrevious}
            >
              <ChevronLeft className="btn__icon" aria-hidden />
              <span className="playback__word">Previous</span>
            </Button>
          </Tooltip>
          <span className="playback__position" aria-live="polite">
            {position}
          </span>
          <Tooltip label="Next">
            <Button
              variant="quiet"
              aria-label="Next"
              disabled={!canNext}
              onClick={onNext}
            >
              <span className="playback__word">Next</span>
              <ChevronRight className="btn__icon" aria-hidden />
            </Button>
          </Tooltip>
        </div>
        {children ? <div className="playback__end">{children}</div> : null}
      </div>
    </div>
  )
}
